import { render, staticRenderFns } from "./ClientGeneralInfoForm.vue?vue&type=template&id=78ccde32&scoped=true&"
import script from "./ClientGeneralInfoForm.js?vue&type=script&lang=js&"
export * from "./ClientGeneralInfoForm.js?vue&type=script&lang=js&"
import style0 from "./ClientGeneralInfoForm.scss?vue&type=style&index=0&id=78ccde32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ccde32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VProgressCircular,VRow,VSelect,VTextField,VTextarea})
